import { render, staticRenderFns } from "./SceneMatch.vue?vue&type=template&id=071b7cd2&scoped=true&"
import script from "./SceneMatch.vue?vue&type=script&lang=js&"
export * from "./SceneMatch.vue?vue&type=script&lang=js&"
import style0 from "./SceneMatch.vue?vue&type=style&index=0&id=071b7cd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b7cd2",
  null
  
)

export default component.exports